import * as React from 'react';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetTranslations } from '@/generated/translations';
import { DotButton, DotButtonProps } from './DotButton';

export const DotButtonWithOverrides: React.FC<DotButtonProps> = (props) => {
	const { segmentationId } = React.useContext(SegmentationContext);
	const { data: translations } = useGetTranslations(segmentationId);
	return <DotButton {...props} label={translations?.data.shared.slide} />;
};
